import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('requerimentos');

export const check = () => useBasicAuth.checkToken();

export const findRequerimentoById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimento = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimentoWithCidades = () => 
  axios.get(urlAPI + "/findAllWithCidades", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimentoWithCidadesByEstadoCidade = (request) => 
  axios.post(urlAPI + "/findAllWithCidadesByEstadoCidade/",  JSON.stringify(request), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });


export const findAllRequerimentoByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllRequerimentoByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

// export const addRequerimento = (obj) => 
//   axios.post(urlAPI + "/addRequerimento" , JSON.stringify(obj), environment.HEADER)
//   .then(({data}) => data)
//   .catch(e => {
//     useBasicAuth.handleError(e);
//   });

export const updateRequerimento = (obj) => 
  axios.put(urlAPI + "/updateRequerimento/" + obj.requerimento.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

// export const deleteRequerimento = (id) => 
//   axios.delete(urlAPI + "/deleteRequerimento/" + id, environment.HEADER)
//   .then(({data}) => data)
//   .catch(e => {
//     useBasicAuth.handleError(e);
//   });



//REQUERIMENTO_CIDADE
export const findAllByRequerimentoCidade_requerimento = (requerimento) => 
  axios.post(urlAPI + "/byCidade/requerimento", JSON.stringify(requerimento), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByRequerimentoCidade_cidade = (cidade) => 
  axios.post(urlAPI + "/byCidade/cidade", JSON.stringify(cidade), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByRequerimentoCidade = (requerimento, cidade) => {
  let requestObj = {
    requerimento: requerimento,
    cidade: cidade
  }
  axios.post(urlAPI + "/byCidade", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}


//REQUERIMENTO_ESTADO
export const findAllByRequerimentoEstado_requerimento = (requerimento) => 
  axios.post(urlAPI + "/byEstado/requerimento", JSON.stringify(requerimento), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByRequerimentoEstado_estado = (estado) => 
  axios.post(urlAPI + "/byEstado/estado", JSON.stringify(estado), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllByRequerimentoEstado = (requerimento, estado) => {
  let requestObj = {
    requerimento: requerimento,
    estado: estado
  }
  axios.post(urlAPI + "/byEstado", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}









export const syncRequerimento = (requestObj) => 
  axios.post(urlAPI + "/syncRequerimento/",  JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });